import { IToastConfig } from 'src/common/primitives/Toast';

export function generateSuccessToast(id: number): IToastConfig {
  return {
    id,
    title: `A vehicle has been added!`,
  };
}
